import { useMarkerNoteByline } from "components/SmartSurveyor/shared/MarkerNoteCard";
import type { ElementNoteBylineProps } from "./types";

export const ElementNoteByline = ({ note }: ElementNoteBylineProps) => {
  const { author, timeLabel } = useMarkerNoteByline({ note });

  return (
    <div className="mb-1 flex flex-wrap items-baseline gap-x-1.5 text-xs">
      <span className="min-w-0 break-words font-medium text-gray-700">
        {author}
      </span>
      <span className="whitespace-nowrap text-gray-400">· {timeLabel}</span>
    </div>
  );
};
